export const EVENTS = {
  TICKETS: {
    // Fetch/Query
    FETCH: 'tickets.fetch',
    FETCH_SUCCESS: 'tickets.fetch_success',
    FETCH_ERROR: 'tickets.fetch_error',
    LOAD_MORE: 'tickets.load_more',

    // Single Ticket
    FETCH_BY_ID: 'tickets.fetch_by_id',
    FETCH_BY_ID_SUCCESS: 'tickets.fetch_by_id_success',
    FETCH_BY_ID_ERROR: 'tickets.fetch_by_id_error',

    // Search/Filter
    SEARCH: 'tickets.search',
    FILTER: 'tickets.filter',
    UPDATE_FILTERS: 'tickets.update_filters',

    // Categories
    FETCH_CATEGORIES: 'tickets.fetch_categories',
    CATEGORY_CHANGED: 'tickets.category_changed',

    // Favorites
    TOGGLE_FAVORITE: 'tickets.toggle_favorite',
    FAVORITE_ADDED: 'tickets.favorite_added',
    FAVORITE_REMOVED: 'tickets.favorite_removed',

    // Related
    FETCH_RELATED: 'tickets.fetch_related',
  }
};

export const ENDPOINTS = {
  TICKETS: {
    LIST: '/tickets',
    DETAIL: '/tickets/{id}',
    SEARCH: '/tickets/search',
    CATEGORIES: '/tickets/categories',
    RELATED: '/tickets/{id}/related',
    AVAILABILITY: '/tickets/{id}/availability',
  }
};

export const CATEGORIES = [
  { id: 'all', label: 'Tout', icon: '' },
  { id: 'concerts', label: 'Concerts', icon: '' },
  { id: 'sports', label: 'Sports', icon: '' },
  { id: 'theatre', label: 'Théâtre', icon: '' },
  { id: 'festivals', label: 'Festivals', icon: '' },
  { id: 'comedy', label: 'Humour', icon: '' },
  { id: 'expos', label: 'Expos', icon: '' },
];
